import { getCurrentInstance } from 'vue';
export * from './route';
export * from './store';
export * from './emitter';
export * from './useI18n';
export * from './usePagination';
export * from './useSort';
export * from './useSearch';
export * from './useAsyncFn';
export * from './useCreateSharedComposable';
export * from './useTimeoutFn';
export * from './useOnClickOutside';
export * from './useCreateContext';
export * from './useDelayFn';
export * from './watchThrottled';
export * from './useImageZoom';
export * from './useIntervalFn';
export { useForm, useFormGuard } from './useForm';
export * from './useClientDataExplorer';
export * from './useStorage';
export * from './useAgent';
export * from './useEmoji';
export * from './useFeaturebase';

// See flipper/README.md for complete documentation and usage examples.
export { useFlipper } from './flipper';

export * from './useInfiniteScroll';
export * from './useFrontendUrl';
export * from './useListSelection';

export const useTrack = () => {
  const vm = getCurrentInstance();
  if (!vm) throw new Error('must be called in setup');

  return vm.proxy.$track;
};

export function useAlert(message, action) {
  window.bus.$emit('newToastMessage', message, action);
}
